(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusControllers', [
            'services.authenticatedUser',
            'businessPlanningModule',
            'governanceProcessModule'
        ]);
})();
